import queries from '@apis/queries';
import Card from '@components/Card';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface Props {
    cardId: string;
}

function PrepaidCardInfo({ cardId }:Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(queries.userPrepaidCard.detail(cardId));
    return (
        <Wrapper>
            <InfoCard>
                <Row spacing={16}>
                    <Image src={data?.imageUrl}
                        width={90}
                        height={60}
                        alt={t('components.info.cardAlt')} />
                    <Text size='lg'>
                        {data?.name}
                    </Text>
                </Row>
            </InfoCard>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: var(--color-gray2);
    max-width: var(--max-view-port-width);
    padding: 30px 20px;
    width: 100%;
`;

const InfoCard = styled(Card)`
    padding: 16px;
`;

export default PrepaidCardInfo;
